export default "__VITE_PUBLIC_ASSET__cb57a15a__"